import { render, staticRenderFns } from "./GovPaySuccess.vue?vue&type=template&id=4383a377&"
import script from "./GovPaySuccess.vue?vue&type=script&lang=js&"
export * from "./GovPaySuccess.vue?vue&type=script&lang=js&"
import style0 from "./GovPaySuccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports